import Vue from "vue";

import Title from "./Title";
import Input from "./Input";
import Button from "./Button";
import Select from "./Select";
import Label from "./Label";
import OverlaySpinner from "./OverlaySpinner";
import Spinner from "./Spinner";
import Search from "./Search";
import Datepicker from "./Datepicker";
import CardModal from "./CardModal";
import ImageModal from "./ImageModal";
import Colorpicker from "./Colorpicker";

Vue.component(`LynxTitle`, Title);
Vue.component(`LynxInput`, Input);
Vue.component(`LynxButton`, Button);
Vue.component(`LynxSelect`, Select);
Vue.component(`LynxLabel`, Label);
Vue.component(`Lynx-OverlaySpinner`, OverlaySpinner);
Vue.component(`Lynx-Spinner`, Spinner);
Vue.component(`LynxSearch`, Search);
Vue.component(`LynxDatepicker`, Datepicker);
Vue.component(`LynxColorpicker`, Colorpicker);
Vue.component(`LynxCardModal`, CardModal);
Vue.component(`LynxImageModal`, ImageModal);
